var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGaugeHigh = function SvgGaugeHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0FDF4",
    d: "M1.893 11a6.667 6.667 0 1 1 11.547 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M1.893 11a6.667 6.667 0 1 1 11.547 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#gauge_high_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M1.893 11a6.667 6.667 0 1 1 11.547 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#22C55E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M8 7.667 10.667 5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gauge_high_svg__a",
    x1: -0.833,
    x2: 16.167,
    y1: 7.833,
    y2: 8.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#179CDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308,
    stopColor: "#30D382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22C55E"
  })))));
};
export default SvgGaugeHigh;